import React from "react";
import ReactImageGallery, { ReactImageGalleryProps } from "react-image-gallery";

import Loadable from "@/mk2/helpers/Loadable";

const FIX_DELAY = 600;
/**
 * Older devices will fire 'touchstart' and then 'click' event even if the event.preventDefault() was called.
 * So this fix should detect this and ignore 'click' event.
 */
function fixTouchStartAndClick(fnc) {
    let previous;

    return function (...args: any[]) {
        const event = args[0];
        if (event && event.type === "touchstart") {
            previous = event.timeStamp;
        }
        if (event && event.type === "click") {
            this.clicked = this.clicked || [];
            this.clicked.push(event.timeStamp - previous);

            if (event.timeStamp - previous < FIX_DELAY) {
                // ignore
                return;
            }
        }
        return fnc.apply(this, args);
    };
}

interface OwnProps extends ReactImageGalleryProps {
    forwardedRef?(ref: ReactImageGallery);
}

export const ImageGalleryLoadable = Loadable<OwnProps, typeof ReactImageGallery>({
    loader: () =>
        import("react-image-gallery" /* webpackChunkName: "react-image-gallery" */).then(
            (module) => {
                const ReactImageGalleryClass: typeof ReactImageGallery = module.default;
                (ReactImageGalleryClass.prototype as any)._slideLeft = fixTouchStartAndClick(
                    (ReactImageGalleryClass.prototype as any)._slideLeft,
                );
                (ReactImageGalleryClass.prototype as any)._slideRight = fixTouchStartAndClick(
                    (ReactImageGalleryClass.prototype as any)._slideRight,
                );
                return ReactImageGalleryClass;
            },
        ),
    modules: ["react-image-gallery"],
    webpack: () => [require.resolveWeak("react-image-gallery")],
    render(Component, props) {
        const { forwardedRef, ...rest } = props;
        return <Component {...rest} ref={forwardedRef} />;
    },
});
